import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { formatNumbersWithUnits } from '../../utils/formatNumbers';
import { getMetricChangeValueColorAndIcon } from '../../utils/widgets-ui';
import { MetricChangeValue, StyledIcon } from '../widgets-ui/kpi';
import { LoadingSpinnerInline } from '../heatmap-page-components/styled';

const formatUpliftPercentage = (value, unit) => {
  if (value === null) {
    return '-';
  }
  return formatNumbersWithUnits((unit === 'percentage' ? value : value * 100.0), 'percentage')
}

const MetricChangeComponent = ({ value, unit }) => {
  const theme = useContext(ThemeContext);

  const { color, icon } = getMetricChangeValueColorAndIcon(value, theme);

  return (
    <>
      {value !== undefined ? (
        <MetricChangeValue color={color}>
          {formatUpliftPercentage(value, unit)}
          {icon !== 'blank' && (
            <StyledIcon icon={icon} color={color} iconSize={19} />
          )}
        </MetricChangeValue>
      ) : (
        <LoadingSpinnerInline size={30} />
      )}
    </>
  );
};

export default MetricChangeComponent;